import React from "react";
import SingleJobItem from "../../../helpers/Common/SingleJobItem";
import Nojob from "./Nojob";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
} from "reactstrap";

const JobVacancyListing = ({ jobs, currentPage, totalPages, onPageChange }) => {
const activeJobs = jobs?.filter((job) => job?.canApply === true);

  // Helper function to render dynamic page numbers with ellipsis windowing
  const renderPaginationItems = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <PaginationItem key={1}>
          <PaginationLink onClick={() => onPageChange(1)}>1</PaginationLink>
        </PaginationItem>,
      );
      if (startPage > 2) {
        pages.push(
          <PaginationItem disabled key="start-ellipsis">
            <PaginationLink>...</PaginationLink>
          </PaginationItem>,
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PaginationItem active={i === currentPage} key={i}>
          <PaginationLink onClick={() => onPageChange(i)}>{i}</PaginationLink>
        </PaginationItem>,
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <PaginationItem disabled key="end-ellipsis">
            <PaginationLink>...</PaginationLink>
          </PaginationItem>,
        );
      }
      pages.push(
        <PaginationItem key={totalPages}>
          <PaginationLink onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return pages;
  };

  return (
    <React.Fragment>
      {activeJobs && activeJobs.length > 0 ? (
        <>
          {activeJobs.map((jobDetails, key) => (
            <SingleJobItem
              jobDetails={jobDetails}
              key={jobDetails?.id || key}
            />
          ))}

          {/* Pagination UI inside list component */}
          {totalPages > 1 && (
            <Row className="mt-4 mb-4">
              <Col lg={12}>
                <Pagination className="pagination-rounded justify-content-center">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink first onClick={() => onPageChange(1)} />
                  </PaginationItem>
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => onPageChange(currentPage - 1)}
                    />
                  </PaginationItem>

                  {renderPaginationItems()}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => onPageChange(currentPage + 1)}
                    />
                  </PaginationItem>
                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      last
                      onClick={() => onPageChange(totalPages)}
                    />
                  </PaginationItem>
                </Pagination>
              </Col>
            </Row>
          )}
        </>
      ) : (
        <Nojob />
      )}
    </React.Fragment>
  );
};

export default JobVacancyListing;
